<template>
    <div class="home_bookmarks_list">
        <div class="home_bookmarks_list_header" @click="toggleItemsList">
            <span class="icon_book"></span>
            <span class="title"><strong>ブックマーク</strong></span>
            <span class="icon_arrow" :class="{down: toggle}"></span>
        </div>

        <div class="body" v-show="toggle">
            <div class="items_list light_green">
                <div class="item" v-for="item in bookmarks" @click="handleClickBookmarkItem(item)">
                    <span class="text">{{item.institution.official_name_kanji}}</span>
                    <span class="text large">
                        <strong>{{item.company.short_name}} {{item.maker_product_name !== 'その他' ? item.maker_product_name : ''}}</strong>
                    </span>
                    <span class="text small">{{item.created_at | dateTimeFormat}}</span>
                    <span class="item_button button button_small button_rounded tree_green"
                          @click.stop="handleClickBookmarkButton(item)">
                        <span class="icon icon_book"></span> ブックマークを外す
                    </span>
                </div>
            </div>
        </div>

        <Modal title="ブックマークを外す"
               content="ブックマークを外しても良いですか?"
               v-show="showBookmarkModal"
               @ok="unBookmark"
               @cancel="showBookmarkModal = false"
        />
    </div>
</template>

<script>
  import Modal from '@/components/modal'
  import ChatGroupApi from '@/api/chat-group'
  import MessageApi from '@/api/message'
  import _ from 'lodash'

  export default {
    components: {
      Modal
    },
    data () {
      return {
        toggle: false,
        showBookmarkModal: false,
        bookmarks: [],
        modalItem: {}
      }
    },
    methods: {
      toggleItemsList () {
        this.toggle = !this.toggle
      },
      handleClickBookmarkItem (item) {
        const chatGroupId = item.chat_group.id
        const messageId = item.bookmark_message.id
        this.$router.push({name: 'chat', params: {chatGroupId, messageId}})
      },
      handleClickBookmarkButton (item) {
        this.modalItem = item
        this.showBookmarkModal = true
      },
      async fetchData () {
        const res = await ChatGroupApi.getBookmarks()
        this.bookmarks = res.data.data
      },
      async unBookmark () {
        const loading = this.$loading.show()
        const messageId = this.modalItem.bookmark_message.id
        await MessageApi.unBookmark(messageId)
        _.remove(this.bookmarks, n => n.bookmark_message.id === messageId)
        this.modalItem = {}
        this.showBookmarkModal = false
        loading.hide()
      }
    },
    mounted () {
      this.fetchData()
    }
  }
</script>



// WEBPACK FOOTER //
// src/screens/home/bookmarks.vue